/** @file useHeldWhile: a value that stops changing while `hold` is true and catches up when it ends. */
import { useEffect, useState } from 'react';

/** Returns `value`, except that during `hold` it keeps the last value seen before the hold began. */
export function useHeldWhile<T>(value: T, hold: boolean): T {
  const [shown, setShown] = useState(value);
  useEffect(() => { if (!hold) setShown(value); }, [value, hold]);
  return hold ? shown : value;
}
